import { constructStack } from "@aws-sdk/middleware-stack";
var Command = (function () {
    function Command() {
        this.middlewareStack = constructStack();
    }
    return Command;
}());
export { Command };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/smithy-client/dist-es/command.js
// module id = 639
// module chunks = 0